import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Completion Certificates',
	url: '/forms/completion_certificates',
	icon: 'archive',
}];

export default class Completion_Certificates extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Collections.CompletionCertificates
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

			</div>
		);
	}
}

